<section
  class="toggle-form"
  [ngClass]="{ active: isHierarchySliderOpen }"
>
  <p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
  <div class="formwrap">
    <div class="Header">
      <h1>
        <b>{{ hierarchySliderTitle }}</b>
      </h1>
      <p-button
        appPreventDoubleClick
        styleClass="p-button-text"
        id="hierarchySliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>
    <div class="general-container">
      <div class="tree-container">
        <app-update-tree 
          [treeData]="treeData"
          (onTreeChange)="onTreeChange($event)"
        ></app-update-tree>
      </div>
      <div class="button-container">
        <p-button 
          appPreventDoubleClick
          type="button" 
          label="Save" 
          styleClass="bpt-button-compact"
          [disabled]="!hasChanges"
          id="saveHierarchyButton"
          (debounceClick)="onSave()"
        ></p-button>
      </div>
    </div>
  </div>
</section>
